import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { NumberFixed } from '@delmonicos/shared-design-system-react/src/components/number-fixed/number-fixed';
import { GapEnum } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import classNames from 'classnames';
import { endOfMonth, formatISO, startOfMonth, subMonths } from 'date-fns';
import { useTranslation } from 'react-i18next';

import {
  useCpmsBoGetRevenueForecastQuery,
  useCpmsBoGetRevenueQuery,
} from '@service/cpms-bo-transaction-reports-revenue-statistics.service';

import * as css from '../statistics.module.scss';

export const RevenueCard = (): React.JSX.Element => {
  const { t } = useTranslation();

  const { data: previousMonthData } = useCpmsBoGetRevenueQuery({
    transactionEndedAtAfter: formatISO(startOfMonth(subMonths(new Date(), 1))),
    transactionEndedAtBefore: formatISO(endOfMonth(subMonths(new Date(), 1))),
  });

  const { data: currentMonthData } = useCpmsBoGetRevenueQuery({
    transactionEndedAtAfter: formatISO(startOfMonth(new Date())),
    transactionEndedAtBefore: formatISO(endOfMonth(new Date())),
  });

  const { data: forecastedData } = useCpmsBoGetRevenueForecastQuery({});

  return (
    <Card gap={GapEnum.M}>
      <AccentTitle
        variant={AccentVariantEnum.Accent1}
        icon="currency-euro-circle"
        text={t('$.dashboard.statistics.revenue.title')}
      />
      <div className={classNames(css.revenue, css.previousMonth)}>
        <NumberFixed
          bold
          color={TextColor.Primary}
          fontSize={TextFontSize.Inherit}
          number={previousMonthData?.total ?? 0}
          digits={0}
        />
        <Text>{t('$.dashboard.statistics.revenue.unit')}</Text>
      </div>
      <div className={classNames(css.revenue, css.currentMonth)}>
        <NumberFixed
          bold
          color={TextColor.Primary}
          fontSize={TextFontSize.Inherit}
          number={currentMonthData?.total ?? 0}
          digits={0}
        />
        <Text>{t('$.dashboard.statistics.revenue.unit')}</Text>
      </div>
      <div className={classNames(css.forecasted)}>
        <NumberFixed
          bold
          fontSize={TextFontSize.Inherit}
          number={forecastedData?.total ?? 0}
          digits={0}
        />
        <Text>{t('$.dashboard.statistics.revenue.unit')}</Text>
      </div>
    </Card>
  );
};
